export default __webpack_public_path__ + "static/media/servers.4961651a.svg";